import React, { useEffect } from 'react';
import { toAbsoluteUrl } from '../services/seo';

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, image, url }) => {
  useEffect(() => {
    // Update Title
    const fullTitle = `${title} | FuturePath Teens`;
    document.title = fullTitle;

    const absoluteUrl = toAbsoluteUrl(url || window.location.hash.replace('#', '') || '/');
    const absoluteImage = image ? toAbsoluteUrl(image) : toAbsoluteUrl('/images/careers/_placeholders/fpt-placeholder-card.webp');

    // Helper to update or create meta tags
    const updateMeta = (name: string, content: string, attribute: 'name' | 'property' = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard Meta
    updateMeta('description', description);

    // Open Graph
    updateMeta('og:title', fullTitle, 'property');
    updateMeta('og:description', description, 'property');
    updateMeta('og:type', 'website', 'property');
    updateMeta('og:image', absoluteImage, 'property');
    updateMeta('og:url', absoluteUrl, 'property');
    updateMeta('og:site_name', 'FuturePath Teens', 'property');

    // Canonical Link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', absoluteUrl);

  }, [title, description, image, url]);

  return null;
};

export default SEO;
